import { ApiStrings } from "./ApiStrings";
import { IChallenge } from "../models/IChallenge";

function MapChallengeDboArray(json: any): IChallenge[] {
  let challengesList: IChallenge[] = [];
  for (var guid in json) {
    if (json.hasOwnProperty(guid)) {
      let challengeDbo = json[guid];
      challengesList.push(MapChallengeDbo(guid, challengeDbo));
    }
  }
  return challengesList;
}

function MapChallengeDbo(guid: string, challengeDbo: any): IChallenge {
  return {
    Guid: guid,
    Title: challengeDbo.Title,
    Subtitle: challengeDbo.Subtitle,
    Tags: challengeDbo.Tags,
    CreatedAt: challengeDbo.CreatedAt,
    Region: challengeDbo.Region,
    ImageSrc: challengeDbo.ImageSrc,
    CallToActions: challengeDbo.CallToActions,
    BeenFeatured: challengeDbo.BeenFeatured,
    StartCount: challengeDbo.StartCount,
    ShareCount: challengeDbo.ShareCount,
    UpVotes: challengeDbo.UpVotes,
    DownVotes: challengeDbo.DownVotes,
    Theme: challengeDbo.Theme,
  };
}

export class ApiService {
  readonly ChallengeApiUrl = ApiStrings.BaseUrl + ApiStrings.ChallengesSlag;
  readonly GetSingleChallengeUrl = this.ChallengeApiUrl + "?id=";
  readonly GetThemesUrl = ApiStrings.BaseUrl + ApiStrings.ThemesSlag;
  readonly GetChallengesByThemeUrl = this.GetThemesUrl + "?name=";

  async GetChallenges(pageNumber?: number): Promise<IChallenge[] | undefined> {
    const query =
      pageNumber !== undefined
        ? `${this.ChallengeApiUrl}?${ApiStrings.PageQuery}${pageNumber}`
        : this.ChallengeApiUrl;

    try {
      const response = await fetch(query);
      if (!response.ok) throw Error(response.statusText);
      const json = await response.json();

      return MapChallengeDboArray(json);
    } catch (error) {
      console.log("Whooops: ", error);
      return undefined;
    }
  }

  async GetSingleChallenge(docId: string): Promise<IChallenge | null> {
    return fetch(this.GetSingleChallengeUrl + docId)
      .then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then(function (json) {
        return MapChallengeDbo(docId, json);
      })
      .catch(function (error) {
        console.log("Whooops: ", error);
        return null;
      });
  }

  async createChallenge(json: any): Promise<any> {
    return fetch(this.ChallengeApiUrl, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    })
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => {
        console.error("Whooops:", error);
      });
  }

  async GetChallengesByTheme(
    theme: string,
    page?: number
  ): Promise<IChallenge[] | undefined> {
    const baseThemeURL =
      this.GetChallengesByThemeUrl + encodeURIComponent(theme);

    const query =
      page !== undefined
        ? `${baseThemeURL}&${ApiStrings.PageQuery}${page}`
        : baseThemeURL;

    try {
      const response = await fetch(query);
      if (!response.ok) throw Error(response.statusText);
      const json = await response.json();

      return MapChallengeDboArray(json);
    } catch (error) {
      console.log("Whooops: ", error);
      return undefined;
    }
  }
}
